import React, { useEffect, useState } from 'react';
import { CheckCircle2, XCircle, Shield, ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
const CHECKOUT_URL = 'https://megapack-life-coach.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 34
  });
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const faqs = [{
    q: '¿Sirve para cualquier tipo de life coach?',
    a: 'Sí. Las sesiones están organizadas por tema (autoconocimiento, creencias, emociones, hábitos, relaciones, propósito) y funcionan con cualquier metodología: ontológica, PNL, ICF o formación propia.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Descarga inmediata en PDF apenas confirmas la compra. Lo abres en computadora, tablet o celular, y puedes imprimir todo lo que necesites.'
  }, {
    q: '¿Puedo usar el material con mi marca?',
    a: 'Sí. El cuaderno del cliente y los entregables están diseñados para que les pongas tu logo y los uses con tus clientes.'
  }, {
    q: '¿Es un curso? ¿Tengo que estudiar algo?',
    a: 'No. Es material listo para usar. Abres el tomo, eliges la sesión y la das. Cero teoría de relleno.'
  }, {
    q: '¿Sirve si recién me certifiqué y todavía no tengo clientes?',
    a: 'Especialmente. Los bonos de Roleplays y Errores Típicos están pensados exactamente para darte seguridad en tus primeras sesiones.'
  }, {
    q: '¿Y si no me sirve?',
    a: 'Garantía de 7 días con devolución total, sin preguntas.'
  }];
  return <div className="w-full bg-cream" data-id="element-141">
      {/* URGENCY */}
      <section className="py-12 bg-brand-900 text-white text-center px-4" data-id="element-142">
        <div className="max-w-3xl mx-auto" data-id="element-143">
          <div className="inline-block bg-red-500 text-white font-bold px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-144">
            🛑 PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="flex justify-center gap-4 text-4xl md:text-6xl font-black font-mono tracking-tight mb-6" data-id="element-145">
            <div className="flex flex-col" data-id="element-146">
              <span className="text-accent" data-id="element-147">
                {String(timeLeft.hours).padStart(2, '0')}
              </span>
              <span className="text-xs font-sans text-gray-400 uppercase mt-1" data-id="element-148">
                Horas
              </span>
            </div>
            <span className="text-brand-500 pb-6" data-id="element-149">:</span>
            <div className="flex flex-col" data-id="element-150">
              <span className="text-accent" data-id="element-151">
                {String(timeLeft.minutes).padStart(2, '0')}
              </span>
              <span className="text-xs font-sans text-gray-400 uppercase mt-1" data-id="element-152">
                Min
              </span>
            </div>
            <span className="text-brand-500 pb-6" data-id="element-153">:</span>
            <div className="flex flex-col" data-id="element-154">
              <span className="text-accent" data-id="element-155">
                {String(timeLeft.seconds).padStart(2, '0')}
              </span>
              <span className="text-xs font-sans text-gray-400 uppercase mt-1" data-id="element-156">
                Seg
              </span>
            </div>
          </div>
          <p className="text-gray-300 mb-6" data-id="element-157">
            ⚠️ Después sube a $47. No vuelve.
          </p>
          <div className="w-full max-w-md mx-auto bg-brand-800 rounded-full h-3 overflow-hidden" data-id="element-158">
            <div className="bg-accent h-full w-[88%] rounded-full" data-id="element-159"></div>
          </div>
          <p className="text-xs text-gray-400 mt-2" data-id="element-160">
            88% de los cupos al precio de lanzamiento ya reservados
          </p>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-20 px-4 md:px-8 max-w-3xl mx-auto scroll-mt-8" data-id="element-161">
        <div className="text-center mb-12" data-id="element-162">
          <h2 className="text-4xl font-extrabold text-brand-900 mb-4" data-id="element-163">
            Todo incluido, un solo precio
          </h2>
          <p className="text-lg text-gray-600" data-id="element-164">
            Sin planes, sin extras ocultos. Te llevas el sistema completo.
          </p>
        </div>

        <div className="bg-brand-900 rounded-3xl p-8 md:p-10 border-2 border-accent shadow-2xl flex flex-col relative" data-id="element-165">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap" data-id="element-166">
            ⭐ TODO INCLUIDO
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 mt-2" data-id="element-167">
            MEGAPACK LIFE COACH
          </h3>
          <p className="text-brand-100 mb-8" data-id="element-168">
            6 Tomos + 5 Bonos + Kit Programas Premium — Todos tus procesos
            resueltos
          </p>
          <div className="mb-8" data-id="element-169">
            <span className="text-gray-400 line-through text-2xl mr-3" data-id="element-170">
              $153
            </span>
            <span className="text-6xl font-black text-white" data-id="element-171">$19.90</span>
            <span className="text-brand-100 font-medium ml-1" data-id="element-172">USD</span>
          </div>
          <ul className="space-y-4 mb-8" data-id="element-173">
            <li className="flex items-start gap-3" data-id="element-174">
              <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-175" />{' '}
              <span className="text-gray-200" data-id="element-176">
                Los 6 Tomos Completos (400+ páginas)
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-177">
              <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-178" />{' '}
              <span className="text-gray-200" data-id="element-179">
                Los 5 Bonos Estratégicos (valor $78)
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-180">
              <CheckCircle2 className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-181" />{' '}
              <span className="text-white font-bold" data-id="element-182">
                Kit Programas Premium completo
              </span>
            </li>
          </ul>
          <div className="bg-brand-800/50 p-4 rounded-xl mb-8 text-sm text-brand-100" data-id="element-183">
            <strong data-id="element-184">Ideal para:</strong> dejar de cobrar por sesión y empezar a
            vender programas cerrados de $300+
          </div>
          <a href={CHECKOUT_URL} className="w-full block text-center bg-accent hover:bg-accent-hover text-white text-lg font-bold py-4 rounded-xl transition-colors shadow-lg shadow-accent/20" data-id="element-185">
            QUIERO MI MEGAPACK AHORA — $19.90
          </a>
          <div className="flex flex-wrap justify-center gap-4 text-xs text-brand-100 font-medium mt-6" data-id="element-186">
            <span className="flex items-center gap-1" data-id="element-187">
              <Shield className="w-4 h-4" data-id="element-188" /> Garantía 7 días
            </span>
            <span data-id="element-189">⚡ Acceso inmediato</span>
            <span data-id="element-190">🔒 Pago 100% seguro</span>
          </div>
        </div>
      </section>

      {/* UPSELL DETAILS */}
      <section className="py-16 bg-white px-4 md:px-8" data-id="element-191">
        <div className="max-w-4xl mx-auto" data-id="element-192">
          <div className="text-center mb-12" data-id="element-193">
            <h3 className="text-3xl font-bold text-brand-900 mb-4" data-id="element-194">
              💼 ¿Qué agrega el Kit "Programas Premium"?
            </h3>
            <p className="text-xl text-gray-600" data-id="element-195">
              De sesiones sueltas a programas que se venden solos.
            </p>
          </div>

          <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm mb-12" data-id="element-196">
            <table className="w-full text-left border-collapse" data-id="element-197">
              <thead data-id="element-198">
                <tr className="bg-gray-50" data-id="element-199">
                  <th className="p-4 border-b border-gray-200 font-bold text-gray-900" data-id="element-200">
                    Situación
                  </th>
                  <th className="p-4 border-b border-gray-200 font-bold text-red-600 bg-red-50/30" data-id="element-201">
                    ❌ Sin Kit
                  </th>
                  <th className="p-4 border-b border-gray-200 font-bold text-brand-600 bg-brand-50/50" data-id="element-202">
                    ✅ Con Kit
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-203">
                <tr data-id="element-204">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-205">
                    El cliente pregunta "¿cuánto cuestan tus sesiones?"
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-206">
                    Cobras por hora y el cliente compara precios
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-207">
                    Vendes un programa cerrado con nombre y resultado
                  </td>
                </tr>
                <tr data-id="element-208">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-209">
                    El cliente termina el primer mes
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-210">
                    Decide sesión a sesión si continúa
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-211">
                    Ya compró un proceso completo de 8-12 semanas
                  </td>
                </tr>
                <tr data-id="element-212">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-213">
                    Necesitas más ingresos
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-214">
                    Tu único camino: más horas
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-215">
                    Coaching grupal: mismo programa, 4-8 personas
                  </td>
                </tr>
                <tr data-id="element-216">
                  <td className="p-4 text-gray-800 font-medium" data-id="element-217">
                    Vender tu servicio
                  </td>
                  <td className="p-4 text-gray-600 bg-red-50/10" data-id="element-218">
                    Explicas qué es el coaching
                  </td>
                  <td className="p-4 text-brand-900 font-medium bg-brand-50/30" data-id="element-219">
                    Muestras una página de venta profesional
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="bg-brand-50 p-6 md:p-8 rounded-2xl border border-brand-100" data-id="element-220">
            <h4 className="font-bold text-brand-900 mb-4 flex items-center gap-2" data-id="element-221">
              <CheckCircle2 className="w-5 h-5 text-brand-600" data-id="element-222" /> EL KIT
              INCLUYE:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-gray-700 font-medium" data-id="element-223">
              <p data-id="element-224">• Programa "Reinvención Personal" (8 sem)</p>
              <p data-id="element-225">• Programa "Del Caos a la Claridad" (12 sem)</p>
              <p data-id="element-226">• Programa corto de entrada (4 sem)</p>
              <p data-id="element-227">• Guía de precios del mercado</p>
              <p data-id="element-228">• Páginas de venta plantilla</p>
              <p data-id="element-229">• Guión de llamada de venta</p>
              <p data-id="element-230">• Kit de coaching grupal</p>
              <p data-id="element-231">• Contratos listos</p>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-16 bg-cream px-4" data-id="element-232">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 text-center border-2 border-brand-100 shadow-lg" data-id="element-233">
          <Shield className="w-16 h-16 text-brand-500 mx-auto mb-6" data-id="element-234" />
          <h2 className="text-3xl font-bold text-brand-900 mb-4" data-id="element-235">
            GARANTÍA DE 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-236">
            Abre los tomos. Úsalos en tus sesiones reales. Si en 7 días no es lo
            que esperabas: te devolvemos el 100%, sin formularios y sin
            complicaciones.
          </p>
          <p className="text-sm font-bold text-brand-600 bg-brand-50 inline-block px-4 py-2 rounded-full" data-id="element-237">
            Tasa de devoluciones histórica: menos del 1%.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-white px-4 md:px-8" data-id="element-238">
        <div className="max-w-3xl mx-auto" data-id="element-239">
          <h2 className="text-3xl font-bold text-center text-brand-900 mb-12" data-id="element-240">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-241">
            {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-242">
                <button className="w-full px-6 py-4 text-left font-bold text-brand-900 flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" onClick={() => setOpenFaq(openFaq === i ? null : i)} data-id="element-243">
                  {faq.q}
                  {openFaq === i ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-244" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-245" />}
                </button>
                {openFaq === i && <div className="px-6 py-4 bg-white text-gray-600 leading-relaxed" data-id="element-246">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* COST OF NOT HAVING IT */}
      <section className="py-20 bg-brand-900 text-white px-4 md:px-8" data-id="element-247">
        <div className="max-w-4xl mx-auto text-center" data-id="element-248">
          <h2 className="text-3xl md:text-4xl font-bold mb-12" data-id="element-249">
            💸 ¿Cuánto cuesta seguir improvisando?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 text-left" data-id="element-250">
            <div className="bg-brand-800/50 p-6 rounded-2xl" data-id="element-251">
              <h4 className="text-red-400 font-bold mb-4 flex items-center gap-2" data-id="element-252">
                <XCircle className="w-5 h-5" data-id="element-253" /> Sin MegaPack
              </h4>
              <ul className="space-y-4 text-gray-300" data-id="element-254">
                <li data-id="element-255">2 horas de preparación por cliente cada semana</li>
                <li data-id="element-256">Buscar ejercicios sueltos en Google y YouTube</li>
                <li data-id="element-257">Cliente que no percibe un método</li>
                <li data-id="element-258">Inseguridad antes de cada sesión</li>
              </ul>
            </div>
            <div className="bg-brand-800 p-6 rounded-2xl border border-brand-700" data-id="element-259">
              <h4 className="text-brand-300 font-bold mb-4 flex items-center gap-2" data-id="element-260">
                <ArrowRight className="w-5 h-5" data-id="element-261" /> Costo real
              </h4>
              <ul className="space-y-4 text-white font-medium" data-id="element-262">
                <li data-id="element-263">100+ horas al año de trabajo no pago</li>
                <li data-id="element-264">Sesiones sin coherencia entre sí</li>
                <li data-id="element-265">Abandona al 2do mes — pierdes $100-300 por cliente</li>
                <li data-id="element-266">Cobras menos de lo que vales</li>
              </ul>
            </div>
          </div>

          <p className="text-2xl font-serif italic text-accent mb-12" data-id="element-267">
            "Tu próxima sesión puede ser la mejor que has dado."
          </p>

          <div className="bg-white text-brand-900 p-8 md:p-12 rounded-3xl max-w-2xl mx-auto shadow-2xl" data-id="element-268">
            <h3 className="text-2xl font-bold mb-6" data-id="element-269">
              Deja de improvisar. Empieza a coachear con un sistema.
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-270">
              SESIONES. HERRAMIENTAS. GUIONES. SEGUIMIENTO. PROGRAMAS. Todo
              resuelto.
            </p>
            <a href={CHECKOUT_URL} className="w-full bg-brand-600 hover:bg-brand-700 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1 block mb-4" data-id="element-271">
              SÍ, QUIERO MI MEGAPACK LIFE COACH
            </a>
            <div className="flex justify-center items-center gap-2 text-sm text-gray-500" data-id="element-272">
              <Shield className="w-4 h-4" data-id="element-273" /> Garantía de 7 días
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-brand-950 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-274">
        <div className="max-w-4xl mx-auto" data-id="element-275">
          <p className="font-bold text-white mb-2" data-id="element-276">MEGAPACK LIFE COACH™</p>
          <p className="mb-8 max-w-md mx-auto" data-id="element-277">
            El sistema #1 de sesiones listas para life coaches de habla hispana.
            Porque coachear no debería empezar con miedo la noche anterior.
          </p>
          <div className="flex flex-wrap justify-center gap-6" data-id="element-278">
            <a href="#" className="hover:text-white transition-colors" data-id="element-279">
              soporte@tudominio.com
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-280">
              @tuinstagram
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-281">
              Términos y condiciones
            </a>
          </div>
        </div>
      </footer>
    </div>;
}